var map = {
	"./icons/credit-card-logos/dankort.svg": 76245,
	"./icons/credit-card-logos/diners.svg": 62127,
	"./icons/credit-card-logos/jcb.svg": 5913,
	"./icons/credit-card-logos/maestro.svg": 92371,
	"./icons/credit-card-logos/mastercard.svg": 77496,
	"./icons/credit-card-logos/visa.svg": 37547,
	"./icons/dot.svg": 87953,
	"./misc/ageras-logo.svg": 31403,
	"./misc/billy-face-outline.svg": 17047,
	"./misc/billy-logo-white.svg": 47028,
	"./misc/billy-logo.svg": 99220,
	"./misc/billy-shh.svg": 95568,
	"./misc/logo-app-simple.svg": 64942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33424;